import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, Pagination, CircularProgress, Alert, Avatar, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import { client } from '../api/Api';

const RecipesAdminList = () => {
  const [page, setPage] = useState(1);
  const [size] = useState(20);
  const [data, setData] = useState({ content: [], totalElements: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowLoading, setRowLoading] = useState({});

  const load = async (p) => {
    setLoading(true);
    setError(null);
    try {
      const res = await client.get(`/admin/recipes?page=${p - 1}&size=${size}`);
      setData(res.data);
    } catch (e) {
      setError('Nepavyko užkrauti receptų sąrašo');
    } finally {
      setLoading(false);
    }
  };

  const illustrate = async (id) => {
    setRowLoading(prev => ({ ...prev, [id]: true }));
    try {
      const res = await client.post(`/admin/recipes/${id}/illustrate`);
      // Update the specific row in-place if present
      setData(prev => {
        if (!prev?.content) return prev;
        const content = prev.content.map(r => r.id === id ? { ...r, imageId: res.data.imageId } : r);
        return { ...prev, content };
      });
    } catch (e) {
      setError('Nepavyko sugeneruoti iliustracijos');
    } finally {
      setRowLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  useEffect(() => {
    load(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Receptai</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Nuotrauka</TableCell>
                  <TableCell>Produktas</TableCell>
                  <TableCell>Pavadinimas</TableCell>
                  <TableCell>Tipas</TableCell>
                  <TableCell>Kalorijos (kcal)</TableCell>
                  <TableCell>Sukurta</TableCell>
                  <TableCell align="right">Veiksmai</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.content?.map((r) => (
                  <TableRow key={r.id} hover>
                    <TableCell>{r.id}</TableCell>
                    <TableCell>
                      {r.imageId ? (
                        <Avatar variant="rounded" sx={{ width: 56, height: 56 }} src={`/api/images/recipes/${r.imageId}.png`} />
                      ) : (
                        <Avatar variant="rounded" sx={{ width: 56, height: 56 }}>—</Avatar>
                      )}
                    </TableCell>
                    <TableCell>{r.productName || '-'}</TableCell>
                    <TableCell>{r.title || '-'}</TableCell>
                    <TableCell>{r.type || '-'}</TableCell>
                    <TableCell>{r.caloriesKcal ?? '-'}</TableCell>
                    <TableCell>{r.createdAt ? new Date(r.createdAt).toLocaleString() : '-'}</TableCell>
                    <TableCell align="right">
                      <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button component={Link} to={`/admin/recipes/${r.id}`} size="small" variant="contained">Redaguoti</Button>
                        <Button size="small" variant="outlined" onClick={() => illustrate(r.id)} disabled={!!rowLoading[r.id]}>
                          {rowLoading[r.id] ? 'Generuojama…' : (r.imageId ? 'Perkurti iliustr.' : 'Iliustruoti')}
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
                {(!data.content || data.content.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">Įrašų nėra</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" py={2}>
            <Pagination
              count={data.totalPages || 0}
              page={page}
              onChange={(_, p) => setPage(p)}
              color="primary"
            />
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default RecipesAdminList;
